$(function(){
  const mobile_flag = 1024;
  const adaptive_w = $(window).width();
  
  if (adaptive_w < mobile_flag) {
    $('.top-row__mobile-menu').on('click',function(){
        $(this).toggleClass('active');
        $('.main-menu').toggleClass('active');
    });
    $('.instagram_widget__inner').addClass('owl_style')
    let instagramWiget = $('.instagram_widget__inner')
    instagramWiget.owlCarousel({
        lazyLoad: true,
        nav: true,
        navText: "",
        autoplay: true,
        autoplayTimeout: 6000,
        autoplaySpeed: 700,
        margin: 0,
        responsiveClass: true,
        loop: true,
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots:false,
            },
            600: {
                items: 1,
                dots:false,
                nav: true
            },
        }
    });
  }
  if (adaptive_w >= mobile_flag) {
      fixedHeader();
  }

  // Fixed header
  function fixedHeader(){
      let fixed_el = $('.header .top-row'),
          margin_fix_el = $('.header');
      $( window).on('scroll',function() {
          var offtop = $(this).scrollTop();
          if (offtop > 300){
              $(fixed_el).addClass('fixed');
              $(margin_fix_el).addClass('marginFix');
          }
          else{
              $(fixed_el).removeClass('fixed');
              $(margin_fix_el).removeClass('marginFix');
          }
      });
  }
   
  // Tabs
  $('.tabs .tab_nav li').on('click',function(){
      let thisTabsBlock = $(this).parents('.tabs');
      let activeTab = $(this).attr('data-tab');
      $('.tab_nav li',thisTabsBlock).removeClass('active')
      $(this).addClass('active');
      $('.tabs_content .tab',thisTabsBlock).removeClass('active');
      $('.tabs_content .tab[data-tab='+activeTab+']',thisTabsBlock).addClass('active'); 
  }); 

  //******************* Slider and carousels *********************//
  let mainSlider = $('.main-slider__carousel')
  mainSlider.owlCarousel({
      lazyLoad: true,
      nav: true,
      navText: "",
      autoplay: true,
      autoplayTimeout: 15000,
      autoplaySpeed: 700,
      margin: 0,
      responsiveClass: true,
      loop: true,
      responsive: {
          0: {
              items: 1,
              nav: false
          },
          600: {
              items: 1,
              dots:true,
              nav: true
          },
          1000: {
              items: 1,
              nav: true,
              dots: true,
              loop: true
          }
      }
  });


  let personalCarousel = $('.personal-carousel')
  personalCarousel.owlCarousel({
      lazyLoad: true,
      nav: false,
      navText: "",
      autoplay: true,
      autoplayTimeout: 15000,
      autoplaySpeed: 700,
      margin: 30,
      responsiveClass: true,
      loop: true,
      responsive: {
          0: {
              items: 1,
              nav: false,
              dots:false
          },
          600: {
              items: 2,
              dots:true,
              nav: false
          },
          1000: {
              items: 2,
              nav: false,
              dots: true,
              loop: true
          }
      }
  });


  let aboutSlider = $('.about-slider__carousel')
  aboutSlider.owlCarousel({
      lazyLoad: true,
      nav: false,
      navText: "",
      autoplay: true,
      autoplayTimeout: 15000,
      autoplaySpeed: 700,
      margin: 0,
      responsiveClass: true,
      loop: true,
      responsive: {
          0: {
              items: 1,
              nav: false
          },
          600: {
              items: 1,
              dots:true,
              nav: false
          },
          1000: {
              items: 1,
              nav: false,
              dots: true,
              loop: true
          }
      }
  });


  let logoCarousel = $('.logo-carousel__carousel')
  logoCarousel.owlCarousel({
      lazyLoad: true,
      nav: false,
      navText: "",
      autoplay: true,
      autoplayTimeout: 15000,
      autoplaySpeed: 700,
      margin: 0,
      responsiveClass: true,
      loop: true,
      responsive: {
          0: {
              items: 2,
              nav: false
          },
          600: {
              items: 3,
              dots:true,
              nav: false
          },
          1000: {
              items: 5,
              nav: false,
              dots: true,
              loop: true
          }
      }
  });


  let casesCarousel = $('.cases-carousel')
  casesCarousel.owlCarousel({
      lazyLoad: true,
      nav: false,
      navText: "",
      autoplay: true,
      autoplayTimeout: 15000,
      autoplaySpeed: 700,
      margin: 0,
      responsiveClass: true,
      loop: true,
      responsive: {
          0: {
              items: 1,
              nav: false,
              dots:false
          },
          600: {
              items: 1,
              dots:true,
              nav: false
          },
          1000: {
              items: 1,
              nav: false,
              dots: true,
              loop: true
          }
      }
  });


  


  


//   calculator steps animation
(function () {
    let resultFlag = true;
    let resultArray = [];
    $('.calculator-block__box .stepSwith').on('change',function(){
        let thisBlock = $(this).parents('.calculator-block__box');
        $(thisBlock).next('.calculator-block__box').addClass('active');
        
        $('.stepSwith').each(function(){
            if($('option:selected',this).text() == 'Иное'){
                resultFlag = false;
                return false;
            }
            else{
                resultFlag = true;
            }
        });
        if ( $(this).attr('name') == 'calculator-step1' ){
            resultArray[0] = $('option:selected',this).attr('data-param');
            if( $('option:selected',this).val() == "ИП"){
                $('select[name="calculator-step2"] option[value="ОСНО"]').attr('hidden',true);  
            }
            else{
                $('select[name="calculator-step2"] option[value="ОСНО"]').attr('hidden',false); 
            }
            if( $('option:selected',this).val() == "ООО"){
                $('select[name="calculator-step2"] option[value="Патент"]').attr('hidden',true);  
            }
            else{
                $('select[name="calculator-step2"] option[value="Патент"]').attr('hidden',false); 
            }
            makeInput(this);
        }
        if ( $(this).attr('name') == 'calculator-step2' ){
            resultArray[1] = $('option:selected',this).attr('data-param');
            makeInput(this);
        }
        if ( $(this).attr('name') == 'calculator-step3' ){
            resultArray[2] = $('option:selected',this).attr('data-param');
            makeInput(this);
        }
        if ( $(this).attr('name') == 'calculator-step4' ){
            resultArray[3] = $('option:selected',this).attr('data-param');
            chooseText(resultFlag, resultArray);
        }
    });
    let makeInput = function(elem){
        let thisName = $(elem).attr('name')
        if($('option:selected',elem).attr('data-param') == 'Иное'){
            let title = $(elem).prev('.select-style__title').text();
            $('<input>', {
                type: 'text',
                placeholder: title,
                name: `${thisName}_custom`,
                required: 'required'
            }).insertBefore('.finalForm .button');
        }
        else{
            $(`input[name="${thisName}"]`).remove(); 
        }
    };
    let printPrice = function(resultArray){
        let finalPrice = 0;
        switch (resultArray) {
            case 'A,A,A,A':
                finalPrice = 40000;
                break;
            case 'A,A,A,B':
                finalPrice = 45000 
                ;
                break;
            case 'A,A,A,C':
                finalPrice = 55000 
                ;
                break;
            case 'A,A,B,A':
                finalPrice = 40000
                ;
                break;
            case 'A,A,B,B':
                finalPrice = 45000;
                break;
            case 'A,A,B,C':
                finalPrice = 55000;
                break;
            case 'A,A,C,A':
                finalPrice = 40000;
                break;
            case 'A,A,C,B':
                finalPrice = 45000;
                break;
            case 'A,A,C,C':
                finalPrice = 55000;
                break;
            case 'A,B,A,A':
                finalPrice = 40000;
                break;
            case 'A,B,A,B':
                finalPrice = 45000;
                break;
            case 'A,B,A,C':
                finalPrice = 55000;
                break;
            case 'A,B,B,A':
                finalPrice = 40000;
                break;
            case 'A,B,B,B':
                finalPrice = 45000;
                break;
            case 'A,B,B,C':
                finalPrice = 55000 ;
                break;
            case 'A,B,C,a':
                finalPrice = 40000;
                break;
            case 'A,B,C,B':
                finalPrice = 45000;
                break;
            case 'A,B,C,C':
                finalPrice = 55000;
                break;
            case 'A,C,A,A':
                finalPrice = 40000;
                break;
            case 'A,C,A,B':
                finalPrice = 45000;
                break;
            case 'A,C,A,C':
                finalPrice = 55000;
                break;
            case 'A,C,B,A':
                finalPrice = 40000;
                break;
            case 'A,C,B,B':
                finalPrice = 45000;
                break;
            case 'A,C,B,C':
                finalPrice = 55000;
                break;
            case 'A,C,C,A':
                finalPrice = 40000;
                break;
            case 'A,C,C,B':
                finalPrice = 45000;
                break;
            case 'A,C,C,C':
                finalPrice = 55000 ;
                break;
            case 'B,B,A,A':
                finalPrice = 20000;
                break;
            case 'B,B,A,B':
                finalPrice = 25000;
                break;
            case 'B,B,A,C':
                finalPrice = 30000;
                break;
            case 'B,B,B,A':
                finalPrice = 20000;
                break;
            case 'B,B,B,B':
                finalPrice = 25000;
                break;
            case 'B,B,B,C':
                finalPrice = 30000;
                break;
            case 'B,B,C,A':
                finalPrice = 20000;
                break;
            case 'B,B,C,B':
                finalPrice = 25000;
                break;
            case 'B,B,C,C':
                finalPrice = 30000;
                break;
            case 'B,C,A,A':
                finalPrice = 20000;
                break;
            case 'B,C,A,B':
                finalPrice = 25000;
                break;
            case 'B,C,A,C':
                finalPrice = 30000;
                break;
            case 'B,C,C,A':
                finalPrice = 20000;
                break;
            case 'B,C,C,B':
                finalPrice = 25000;
                break;
            case 'B,C,C,C':
                finalPrice = 30000;
                break;
            case 'B,D,B,A':
                finalPrice = 15000;
                break;
            case 'B,D,B,B':
                finalPrice = 20000;
                break;
            case 'B,D,B,C':
                finalPrice = 25000;
                break;
            case 'B,C,B,A':
                finalPrice = 20000;
                break;
            case 'B,C,B,B':
                finalPrice = 25000;
                break;
            case 'B,C,B,C':
                finalPrice = 30000;
                break;
            default:
                finalPrice = 0;
        } 
        return finalPrice;
    };
    let chooseText = function(flag, resultArray){
        let resultText = '';
        if (!flag){
            resultText = 'Для уточнения стоимости услуг обратитесь к нам, заполните форму для заявки' 
        }
        else{
            resultText = `Примерная стоимость услуг: ${ printPrice(resultArray.join()) } руб.<br/>Для уточнения стоимости услуг обратитесь к нам`
        }
        $('.calculator-block__result-text').html(resultText)
    }
    
}());

$('.buttonPrice').on('click',function(){
    let price = $(this).attr('data-price');
    console.log(price);
    $('#modal-form-service input[name="price"]').val(price);
    
})


//   

  //***************** Stable scripts *******************//
  $('input.phone').mask('+7 (000) 000-0000');
  $('input.phone').on('focus',function(){
      $(this).text('+7').val('+7');
  });
  $('#contact_form').on('submit',function(){
      $.fancybox.close();
  });

  // To top
  $( window).on('scroll',function() {
      let offtop = $(this).scrollTop();
      let page_h = document.body.clientHeight;
      if (offtop > 580){$('.totop').fadeIn('fast');}
      else{$('.totop').fadeOut('fast');}
      if(offtop > page_h - 900){
          $('.totop').addClass('stopped')
      }
      else{
          $('.totop').removeClass('stopped')
      }
  });
  $('.totop').on('click',function(){
      $('html, body').animate({ scrollTop: 0 }, 500);
  });

  // page anchor
  try {
      $('.goTo').on('click',function() {
          let dataAnchor = $(this).attr('data-go');
          $('.toThis').each(function() {
              if ($(this).attr('data-go') == dataAnchor) {
                  $('html, body').animate({ scrollTop: $(this).offset().top - 80 }, 500);
              }
          })
      });
  } catch (err) {
      console.log(err);
  }
})